var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaqueMoreBlackHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.01 53.36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    d: "M0 0h40.01v53.36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M5.4 5.12h29.2v11.34H5.4zM5.4 36.65h29.2v11.34H5.4zM5.4 20.88h29.2v11.34H5.4z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MC4wMSA1My4zNiI+DQogIDxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPg0KICAgIDxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+DQogICAgICA8Zz4NCiAgICAgICAgPHJlY3Qgd2lkdGg9IjQwLjAxIiBoZWlnaHQ9IjUzLjM2IiBzdHlsZT0iZmlsbDogI2VkZWRlZCIvPg0KICAgICAgICA8cmVjdCB4PSI1LjQiIHk9IjUuMTIiIHdpZHRoPSIyOS4yIiBoZWlnaHQ9IjExLjM0IiBzdHlsZT0iZmlsbDogIzFkMWQxYiIvPg0KICAgICAgICA8cmVjdCB4PSI1LjQiIHk9IjM2LjY1IiB3aWR0aD0iMjkuMiIgaGVpZ2h0PSIxMS4zNCIgc3R5bGU9ImZpbGw6ICMxZDFkMWIiLz4NCiAgICAgICAgPHJlY3QgeD0iNS40IiB5PSIyMC44OCIgd2lkdGg9IjI5LjIiIGhlaWdodD0iMTEuMzQiIHN0eWxlPSJmaWxsOiAjMWQxZDFiIi8+DQogICAgICA8L2c+DQogICAgPC9nPg0KICA8L2c+DQo8L3N2Zz4NCg==";
export { SvgPlaqueMoreBlackHigh as ReactComponent };